import React from 'react'
import { Link } from 'react-router-dom'
import { useTenant } from '../contexts/TenantContext'

export default function Footer() {
  const { tenant } = useTenant()
  const nome = tenant?.nome || ''

  return (
    <footer className="site-footer">
      <p>© {new Date().getFullYear()} {nome}</p>
      <p>
        <Link to="/politica-privacidade">Política de Privacidade</Link>
        {' · '}
        <Link to="/termos">Termos e Condições</Link>
        {' · '}
        <Link to="/agendar">Agendar</Link>
      </p>
    </footer>
  )
}
